export default class InterceptorManager {
  public handlers: any = [];

  public use(fulfilled: any, rejected: any) {
    this.handlers.push({
      fulfilled,
      rejected
    });
    return this.handlers.length - 1;
  }

  public eject(id: any) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
}
